import MoreOptionsMenu from 'components/generic/MoreOptionsMenu'
import { useModalDispatch } from 'hooks/use-modal'
import { WatchlistsModalId, WatchlistsModalsState } from 'constants/modals'
import api from 'api/graphql/graphql'
import { createCsv, downloadCsv } from 'utils'
import moment from 'moment'
import { CSV_EXPORT_SCHEMA } from 'constants/watchlists'
import { toast } from 'react-toastify'
import { useState } from 'react'
import WTNSpinner from 'components/generic/WTNSpinner'
import { useTranslation } from 'react-i18next'

interface Props {
  id: string
}

const WatchlistOptionsMenu = ({ id }: Props) => {
  const { t: tCommonUI } = useTranslation('strCommonUI')
  const { t: tAlerts } = useTranslation('strAlerts')
  const [isOpen, setIsOpen] = useState(false)
  const [isProcessing, setIsProcessing] = useState(false)
  const { modalDispatch: renameModalDispatch, modalActions: renameModalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.RENAME_WATCHLIST
  >(WatchlistsModalId.RENAME_WATCHLIST)

  const { modalDispatch: deleteModalDispatch, modalActions: deleteModalActions } = useModalDispatch<
    WatchlistsModalsState,
    WatchlistsModalId.DELETE_WATCHLIST
  >(WatchlistsModalId.DELETE_WATCHLIST)
  const handleClose = () => setIsOpen(false)
  const handleEdit = () => {
    handleClose()
    renameModalDispatch(renameModalActions.setValue({ watchlistId: id }))
    renameModalDispatch(renameModalActions.openModal())
  }
  const handleDelete = () => {
    handleClose()
    deleteModalDispatch(deleteModalActions.setValue({ watchlistId: id }))
    deleteModalDispatch(deleteModalActions.openModal())
  }
  const handleExport = async () => {
    handleClose()

    try {
      setIsProcessing(true)
      const watchlist = await api.getWatchlistWithPlayers(id)
      const csvdata = createCsv(watchlist.players, CSV_EXPORT_SCHEMA)
      const timestamp = moment().toISOString().split('.')[0].replaceAll(':', '_')
      const filename = `${watchlist.name.replaceAll(' ', '_')}-${timestamp}`
      downloadCsv(csvdata, { filename })
      toast.success(tAlerts('csvDownload.success'))
    } catch (err) {
      toast.error(tAlerts('csvDownload.error'))
    } finally {
      setIsProcessing(false)
    }
  }

  return (
    <>
      {isProcessing ? (
        <WTNSpinner width={25} hideLogo />
      ) : (
        <MoreOptionsMenu id={id} controls={{ isOpen, setIsOpen }}>
          <li>
            <button onClick={handleExport}>{tCommonUI('button.exportCsv')}</button>
          </li>
          <li>
            <button onClick={handleEdit}>{tCommonUI('button.rename')}</button>
          </li>
          <li>
            <button onClick={handleDelete}>{tCommonUI('button.delete')}</button>
          </li>
        </MoreOptionsMenu>
      )}
    </>
  )
}

export default WatchlistOptionsMenu
